/**
 * @Date: 2020-05-25 15:06
 * @author jiabinbin
 * @Email 425605679@qq.com
 * @Description:
 */
import http from '../http'
export const rateRecordQueryPage = data => {
  return http.request({
    url: '/business/rateRecordQueryPage',
    data,
    method: 'post'
  })
}

// 币种
export const queryAllCurrencyConf = data => {
  return http.request({
    url: '/basic/queryAllCurrencyConf',
    data,
    method: 'get'
  })
}

// 汇率渠道
export const rateChannelQueryList = data => {
  return http.request({
    url: '/basic/rateChannelQueryList',
    data,
    method: 'get'
  })
}

// 商户简称
export const merchantSimpleNameQueryList = data => {
  return http.request({
    url: '/basic/merchantSimpleNameQueryList',
    data,
    method: 'get'
  })
}
